import request from '@/utils/request'

const url = '/home/goods/'
const api = {
  delOrAddCollect (data) {
    return request({
      url: url + 'delOrAddCollect',
      method: 'post',
      data
    })
  },
  Query (data) {
    return request({
      url: url + 'getGoodsList',
      method: 'post',
      data
    })
  },
  getCartList (data) {
    return request({
      url: url + 'getCartList',
      method: 'post',
      data
    })
  },
  addCart (data) {
    return request({
      url: url + 'addCart',
      method: 'post',
      data
    })
  },
  delCart (data) {
    return request({
      url: url + 'delCart',
      method: 'post',
      data
    })
  },
  getGoodsDetail (data) {
    return request({
      url: url + 'getGoodsDetail',
      method: 'post',
      data
    })
  },
  attrFiltrate (data) {
    return request({
      url: url + 'attrFiltrate',
      method: 'post',
      data
    })
  },
  moveCollect (data) {
    return request({
      url: url + 'moveCollect',
      method: 'post',
      data
    })
  },
  cartCheckList (data) {
    return request({
      url: url + 'cartCheckList',
      method: 'post',
      data
    })
  },
  batchAddCart (data) {
    return request({
      url: url + 'batchAddCart',
      method: 'post',
      data
    })
  },
  getNowBuyGoods (data) {
    return request({
      url: url + 'getNowBuyGoods',
      method: 'post',
      data
    })
  },
  getFastList (data) {
    return request({
      url: url + 'getFastList',
      method: 'post',
      data
    })
  },
  updateCart (data) {
    return request({
      url: url + 'updateCart',
      method: 'post',
      data
    })
  },
  updateCartLeave (data) {
    return request({
      url: url + 'updateCartLeave',
      method: 'post',
      data
    })
  },
  httpPriceList (data) {
    return request({
      url: url + 'httpPriceList',
      method: 'post',
      data
    })
  },
  goodsCategory (data) {
    return request({
      url: url + 'goodsCategory',
      method: 'post',
      data
    })
  },
  getHotcakeList (data) {
    return request({
      url: url + 'getHotcakeList',
      method: 'post',
      data
    })
  },
  getIpAddress (data) {
    return request({
      url: url + 'getIpAddress',
      method: 'post',
      data
    })
  },
  screenCorrelation (data) {
    return request({
      url: url + 'screenCorrelation',
      method: 'post',
      data
    })
  },
  toSearchDetail (data) {
    return request({
      url: '/home/search/dataCollectionPush',
      method: 'post',
      data
    })
  }
}
export default api



// WEBPACK FOOTER //
// ./src/api/goods.js